import React from 'react';
import './TidbitsSection.css';


const tidbits = [
  "My go-to shell prompt is Starship.",
  "The music section below uses the spotify api to maintain current songs",
  "I enjoy cooking and trying new foods",
  "I rowed for 7 years in high school and college"
];

export default function TidbitsSection() {
  return (
    <section className="tidbits-section">
      <h2>Did You Know?</h2>
      <div className="tidbits-grid">
        {tidbits.map((text, idx) => (
          <div key={idx} className="tidbit-card">
            <p className="tidbit-text">{text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}